import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Auth from '../../../../Layout/Auth';

// Lazy load components
const TableList = lazy(() => import('../Pages/RestaurantTableList'));
const EditRestaurantTable = lazy(() => import('../Pages/EditRestaurantTable'));
const AddRestaurantTable = lazy(() => import('../Pages/AddRestaurantTable'));
const RestaurantTableView = lazy(() => import('../Pages/RestaurantTableView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined;

function RestaurantTableRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/restaurant/tables"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <TableList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/restaurant/tables/list"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <TableList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/restaurant/tables/add"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <AddRestaurantTable history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/restaurant/tables/edit/:slack"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <EditRestaurantTable history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/restaurant/tables/view/:slack"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <RestaurantTableView history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
        </Switch>
    );
};

export default RestaurantTableRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
